import { AppState } from '@store/state';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Component, OnInit, Inject, Output, Input, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OrderSearchFormValues } from './_interfaces_/order-search-form.interface';
import { OverviewViewEnumType, OverviewViewEnum } from '@enums/overview-view.enum';
import { Router } from '@angular/router';
import { SearchOrdersPayload } from '@shared/services/order/_interfaces_/orders.interface';
import { Store } from '@ngrx/store';
import { take, finalize } from 'rxjs/operators';
import { UrlPathnameEnum } from '@enums/url-pathname.enum';
import { CommonOrderService } from '@pages/common-order/common-order.service';
import { OrderListItem } from '@pages/common-order/_interfaces_/order.interface';

@Component({
  selector: 'app-all-orders',
  templateUrl: './all-orders.component.html',
})
export class AllOrdersComponent implements OnInit {
  @ViewChild('unavailableOrderModal') unavailableOrderModal: TemplateRef<any>;
  @Input() view: OverviewViewEnumType;
  @Output() toggleView = new EventEmitter<OverviewViewEnumType>();
  modalRef: BsModalRef;
  form: FormGroup;
  loading: boolean;
  orders: OrderListItem[];

  constructor(
    @Inject(BsModalService) private _modalService: BsModalService,
    @Inject(FormBuilder) private _fb: FormBuilder,
    @Inject(CommonOrderService) private _commonOrderService: CommonOrderService,
    @Inject(Router) private _router: Router,
    @Inject(Store) private _store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.form = this._fb.group({
      orderNumber: '',
      pnr: '',
      name: '',
    } as OrderSearchFormValues);
  }

  resetOrders(): void {
    this.form.reset();
    this.orders = null;
    this.toggleView.emit(OverviewViewEnum.OPTION_ORDERS);
  }

  onSubmit(): void {
    const payload = this.serializeSearchOrdersPayload();
    this.toggleView.emit(OverviewViewEnum.ALL_ORDERS);
    this.loading = true;
    this._commonOrderService
      .searchOrders(payload)
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((orders) => {
        this.orders = orders;
      });
  }

  serializeSearchOrdersPayload(): SearchOrdersPayload {
    const formValue = this.form.value;
    const payload = {};
    Object.keys(this.form.value).forEach((key) => {
      if (formValue[key]) {
        payload[key] = formValue[key];
      }
    });

    return payload;
  }

  onOrderClick(order: OrderListItem): void {
    if (order.orderNumber) {
      this._router.navigate([UrlPathnameEnum.CommonOrder, order.orderNumber]);
    } else {
      this.modalRef = this._modalService.show(this.unavailableOrderModal, { class: 'modal-dialog-centered' });
    }
  }

  get isAllOrdersView(): boolean {
    return this.view === OverviewViewEnum.ALL_ORDERS;
  }

  get hasOrderOptions(): boolean {
    return this.orders?.length > 0;
  }
}
